var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafetyLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#69d7f9;}.cls-2{fill:none;stroke:#3a00ba;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.56,70.69a9.62,9.62,0,0,1-6.88-2.56,10.35,10.35,0,0,0-1.83-1.52,1.45,1.45,0,0,0-2.23,1.18l-.1,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.13,68.13s.23,7.8,2.68,7.8,7.07,1.64,7.07-8.84L25,76.37l1.6.92s.24,2.13-3.52,2.13H17.81s-2.68.68-2.68-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.63,69.2C78.43,73.55,66.26,80.71,61,80.71H37.5a22.69,22.69,0,0,1-7.86-2.09L25,76.37l-.09-.05V68.13s.87,6.82,10.69,8.29,26.34,2,31.9,0S80.07,71.76,82.63,69.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.68,70.64h12c.88,0,1.7,0,2.48-.07,9.92-.51,12.32-4.18,15.93-6.55,3.4-2.24,8.29.23,5.35,4.21-.2.27-.45.56-.73.87l-.11.1C78.43,73.55,66.26,80.71,61,80.71H37.5a22.69,22.69,0,0,1-7.86-2.09c-2.35-1-4.25-2-4.67-2.25l-.09-.05V55.88l1-.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.88,55.88s10.46-1.64,15.66,2.3,8.13,5.12,16,4.84c6.23-.21,5.67,7.62,5.67,7.62H38.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.57,77.29a2.14,2.14,0,0,1-2.13,2.13H17.26a2.13,2.13,0,0,1-2.13-2.13V55a2.13,2.13,0,0,1,2.13-2.13h7.18A2.13,2.13,0,0,1,26.57,55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.8,47.32l-9.23,6.85a3.19,3.19,0,0,1-3.66,0l-9.23-6.85a9.64,9.64,0,0,1-3.49-7.25V21.84h29.1V40.07A9.64,9.64,0,0,1,73.8,47.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.24,32.19V30.48a3.11,3.11,0,0,1,3.11-3.11h.78a3.11,3.11,0,0,1,3.11,3.11V33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.38,
    y: 32.98,
    width: 14.72,
    height: 9.64
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyLine);
export default __webpack_public_path__ + "static/media/Safety_Line.af0e70ad736cfccf259749676fced5b0.svg";
export { ForwardRef as ReactComponent };